/******/ (() => { // webpackBootstrap
/*!**************************************************!*\
  !*** ./src/js/components/CartGiftProgressBar.js ***!
  \**************************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CartGiftProgressBar = /*#__PURE__*/function (_HTMLElement) {
  function CartGiftProgressBar() {
    _classCallCheck(this, CartGiftProgressBar);
    return _callSuper(this, CartGiftProgressBar, arguments);
  }
  _inherits(CartGiftProgressBar, _HTMLElement);
  return _createClass(CartGiftProgressBar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _window$sm_orders_gif, _window$sm_orders_gif2, _this$dataset$shippin, _this$dataset, _this$dataset$cartTot, _this$dataset2;
      if (!window.sm_orders_gifts || window.sm_orders_gifts.length === 0) return;
      this.giftThreshold = Number((_window$sm_orders_gif = (_window$sm_orders_gif2 = window.sm_orders_gifts[0]) === null || _window$sm_orders_gif2 === void 0 ? void 0 : _window$sm_orders_gif2.order_minimum) !== null && _window$sm_orders_gif !== void 0 ? _window$sm_orders_gif : 0);
      this.shippingThreshold = Number((_this$dataset$shippin = (_this$dataset = this.dataset) === null || _this$dataset === void 0 ? void 0 : _this$dataset.shippingThreshold) !== null && _this$dataset$shippin !== void 0 ? _this$dataset$shippin : 0);
      this.cartTotal = Number((_this$dataset$cartTot = (_this$dataset2 = this.dataset) === null || _this$dataset2 === void 0 ? void 0 : _this$dataset2.cartTotal) !== null && _this$dataset$cartTot !== void 0 ? _this$dataset$cartTot : 0);
      if (this.giftThreshold === 0) return;
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.deliveryProgressPoint = this.querySelector('[data-progress-point=delivery]');
      this.giftProgressPoint = this.querySelector('[data-progress-point=gift]');
      this.hidden = false;
      if (this.shippingThreshold === 0) {
        this.deliveryProgressPoint.hidden = true;
      }
      if (this.giftThreshold > this.shippingThreshold) {
        this.totalThreshold = this.giftThreshold;
        this.biggestThreshold = 'gift';
        this.updateDeliveryProgressPoint();
        this.updateGiftProgressPoint();
        this.updateProgressBar();
        this.updateMessage();
      } else if (this.shippingThreshold > this.giftThreshold) {
        this.totalThreshold = this.shippingThreshold;
        this.biggestThreshold = 'delivery';
        this.updateGiftProgressPoint();
        this.updateProgressBar();
        this.updateMessage();
      } else {
        this.biggestThreshold = 'equal';
        this.totalThreshold = this.shippingThreshold;
        this.equalProgressPoint = this.querySelector('[data-progress-point=equal]');
        if (!this.equalProgressPoint) return;
        this.querySelectorAll('[data-progress-point]').forEach(function (point) {
          return point.hidden = point.dataset.progressPoint !== 'equal';
        });
        this.querySelector('[data-progress-container]').style.marginBottom = '45px';
        this.updateMessage();
        this.updateProgressPointColor(this.equalProgressPoint, this.shippingThreshold);
      }
    }
  }, {
    key: "updateGiftProgressPoint",
    value: function updateGiftProgressPoint() {
      this.giftProgressPoint.style.left = "".concat(this.giftThreshold / this.totalThreshold * 100, "%");
      this.giftProgressPoint.hidden = false;
      var giftProgressPointPrice = this.giftProgressPoint.querySelector('[data-price]');
      // console.log('giftProgressPointPrice', giftProgressPointPrice);
      if (giftProgressPointPrice) {
        giftProgressPointPrice.textContent = "".concat(this.dataset.currencySign).concat(this.giftThreshold.toFixed(2));
      }
    }
  }, {
    key: "updateDeliveryProgressPoint",
    value: function updateDeliveryProgressPoint() {
      this.deliveryProgressPoint.style.left = "".concat(this.shippingThreshold / this.totalThreshold * 100, "%");
    }
  }, {
    key: "updateProgressPointColor",
    value: function updateProgressPointColor(pointParent, pointPrice) {
      var point = pointParent.querySelector('[data-point]');
      if (this.cartTotal >= pointPrice) {
        point.style.backgroundColor = '#F4F0E8';
      } else {
        point.removeAttribute('style');
      }
    }
  }, {
    key: "updateProgressBar",
    value: function updateProgressBar() {
      var progress = Math.min(this.cartTotal / this.totalThreshold * 100, 100);
      this.progressBar.style.width = "".concat(progress, "%");
      this.updateProgressPointColor(this.giftProgressPoint, this.giftThreshold);
      this.updateProgressPointColor(this.deliveryProgressPoint, this.shippingThreshold);
    }
  }, {
    key: "updateMessage",
    value: function updateMessage() {
      var message = this.querySelector('[data-gift-message]');
      if (!message) return;
      var currencySign = this.dataset.currencySign;
      var cartTotal = this.cartTotal,
        shippingThreshold = this.shippingThreshold,
        giftThreshold = this.giftThreshold,
        biggestThreshold = this.biggestThreshold;
      var messages = {
        gift: "You are ".concat(currencySign).concat((giftThreshold - cartTotal).toFixed(2), " away from free gift"),
        shipping: "You are ".concat(currencySign).concat((shippingThreshold - cartTotal).toFixed(2), " away from free standard delivery"),
        equal: "You are ".concat(currencySign).concat((shippingThreshold - cartTotal).toFixed(2), " away from free standard delivery and free gift")
      };

      // Define threshold order based on biggestThreshold
      var thresholds = [];
      if (biggestThreshold === 'gift') {
        thresholds.push({
          limit: shippingThreshold,
          text: messages.shipping
        });
        thresholds.push({
          limit: giftThreshold,
          text: messages.gift
        });
      } else if (biggestThreshold === 'delivery') {
        thresholds.push({
          limit: giftThreshold,
          text: messages.gift
        });
        thresholds.push({
          limit: shippingThreshold,
          text: messages.shipping
        });
      } else {
        thresholds.push({
          limit: shippingThreshold,
          text: messages.equal
        });
      }

      // Iterate through thresholds and find the first applicable message
      for (var _i = 0, _thresholds = thresholds; _i < _thresholds.length; _i++) {
        var _thresholds$_i = _thresholds[_i],
          limit = _thresholds$_i.limit,
          text = _thresholds$_i.text;
        if (cartTotal < limit) {
          message.textContent = text;
          return;
        }
      }

      // Default message if all thresholds are met
      if (this.shippingThreshold === 0) {
        message.innerHTML = 'Congratulations! <br> You have been granted Free Gift';
      } else {
        message.innerHTML = 'Congratulations! <br> You have been granted Free Delivery and Free Gift';
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('cart-gift-progress-bar')) {
  customElements.define('cart-gift-progress-bar', CartGiftProgressBar);
}
/******/ })()
;